import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { UpgradeDetailsConfig } from '../upgrades-plugin.service';

@Component({
    selector: 'upgrade-details-modal',
    templateUrl: 'upgrade-details.component.html',
    standalone: false
})
export class UpgradeDetailsModalComponent extends BaseModalPageComponent {
  upgrade: any;
  config: UpgradeDetailsConfig[];

  constructor(public selfModal: ModalComponent, location: Location) {
    super(location);
  }

  init(data: any) {
    this.upgrade = data.upgrade;
    this.config = data.config;
  }

  openPresentation() {
    window.open(this.upgrade.presentationUrl, '_blank');
  }
}
